// ! This file was auto-generated from the k2 OpenAPI schema. Do not override this file.
export const Tags = {
    ActivityLog: "ActivityLog",
    Comment: "Comment",
    CycleTime: "CycleTime",
    FieldOverride: "FieldOverride",
    Healthchecks: "Healthchecks",
    LocalField: "LocalField",
    PermissionBundle: "PermissionBundle",
    SigningConfiguration: "SigningConfiguration",
    Stage: "Stage",
    Task: "Task",
    Ticket: "Ticket",
    TicketActions: "TicketActions",
    Turn: "Turn",
    Workflow: "Workflow",
    WorkflowDocument: "WorkflowDocument",
    WorkflowTemplate: "WorkflowTemplate",
    WorkflowVersion: "WorkflowVersion",
    admin: "admin",
    contract_family_node: "contract_family_node",
    documents: "documents",
    integrate_workflow: "integrate-workflow",
    schemas: "schemas",
    service_to_service: "service-to-service",
    ticket_actions: "ticket-actions",
    ticket_comments: "ticket-comments",
    ticket_documents: "ticket-documents",
    ticket_esign_packages: "ticket-esign-packages",
    ticket_fields: "ticket-fields",
    ticket_permission_bundles: "ticket-permission-bundles",
    ticket_sign_tasks: "ticket-sign-tasks",
    ticket_signing_participants: "ticket-signing-participants",
    ticket_stages: "ticket-stages",
    ticket_tasks: "ticket-tasks",
    ticket_turns: "ticket-turns",
    tickets: "tickets",
    workflow_documents: "workflow-documents",
    workflow_field_overrides: "workflow-field-overrides",
    workflow_local_fields: "workflow-local-fields",
    workflow_permission_bundles: "workflow-permission-bundles",
    workflow_templates: "workflow-templates",
    workflows: "workflows",
    wss: "wss"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
